// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.\\------packages-foundation-account-ui-base-src-components-user-info-panel-index-module__update-avatar-PKKWne {
  margin-bottom: 24px;
}

.\\------packages-foundation-account-ui-base-src-components-user-info-panel-index-module__edit-profile-Ij6Gny .coz-icon-button-mini {
  line-height: 1;
}

.\\------packages-foundation-account-ui-base-src-components-user-info-panel-index-module__edit-profile-Ij6Gny .coz-typography {
  color: rgba(var(--coze-fg-3), var(--coze-fg-3-alpha));
}

.\\------packages-foundation-account-ui-base-src-components-user-info-panel-index-module__label-wrap-ejhY3L {
  justify-content: flex-start;
  align-self: flex-start;
  align-items: center;
  gap: 16px;
  width: 100%;
  margin-bottom: 20px;
  display: flex;
}

.\\------packages-foundation-account-ui-base-src-components-user-info-panel-index-module__label-QnKqOS {
  flex: 0 0 112px;
  width: 112px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}

.\\------packages-foundation-account-ui-base-src-components-user-info-panel-index-module__submit-v3XnWF {
  width: 100%;
  margin-top: 48px;
}

.\\------packages-foundation-account-ui-base-src-components-user-info-panel-index-module__count-cZ6U8j {
  color: #737577;
  margin: 0 12px 0 8px;
  font-size: 12px;
  line-height: 16px;
}

.\\------packages-foundation-account-ui-base-src-components-user-info-panel-index-module__upload-button-lPcyvz {
  font-size: 12px;
  line-height: 16px;
}

.\\------packages-foundation-account-ui-base-src-components-user-info-panel-index-module__upload-button-lPcyvz a {
  color: var(--light-usage-primary-color-primary, #0077fa);
  font-weight: 400;
}

.\\------packages-foundation-account-ui-base-src-components-user-info-panel-index-module__filed-readonly-YOi2y9 {
  align-items: center;
  width: 100%;
  display: flex;
}

.\\------packages-foundation-account-ui-base-src-components-user-info-panel-index-module__filed-readonly-YOi2y9 .\\------packages-foundation-account-ui-base-src-components-user-info-panel-index-module__text-EweipQ {
  line-height: 20px;
}

.\\------packages-foundation-account-ui-base-src-components-user-info-panel-index-module__filed-readonly-YOi2y9 > button > button:last-child, .\\------packages-foundation-account-ui-base-src-components-user-info-panel-index-module__filed-readonly-YOi2y9 > button > span:last-child {
  margin-left: 4px;
}

.\\------packages-foundation-account-ui-base-src-components-user-info-panel-index-module__field-edit-Ux2bRL {
  align-items: flex-start;
  width: 100%;
  display: flex;
}

.\\------packages-foundation-account-ui-base-src-components-user-info-panel-index-module__field-edit-Ux2bRL .\\------packages-foundation-account-ui-base-src-components-user-info-panel-index-module__field-edit-children-ej1QSf {
  flex: 1;
}

.\\------packages-foundation-account-ui-base-src-components-user-info-panel-index-module__field-edit-Ux2bRL .\\------packages-foundation-account-ui-base-src-components-user-info-panel-index-module__field-btn-FpBgPL {
  align-self: end;
}

.\\------packages-foundation-account-ui-base-src-components-user-info-panel-index-module__field-edit-Ux2bRL .\\------packages-foundation-account-ui-base-src-components-user-info-panel-index-module__btn-nd94Jo {
  margin-left: 16px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"update-avatar": `------packages-foundation-account-ui-base-src-components-user-info-panel-index-module__update-avatar-PKKWne`,
	"updateAvatar": `------packages-foundation-account-ui-base-src-components-user-info-panel-index-module__update-avatar-PKKWne`,
	"edit-profile": `------packages-foundation-account-ui-base-src-components-user-info-panel-index-module__edit-profile-Ij6Gny`,
	"editProfile": `------packages-foundation-account-ui-base-src-components-user-info-panel-index-module__edit-profile-Ij6Gny`,
	"label-wrap": `------packages-foundation-account-ui-base-src-components-user-info-panel-index-module__label-wrap-ejhY3L`,
	"labelWrap": `------packages-foundation-account-ui-base-src-components-user-info-panel-index-module__label-wrap-ejhY3L`,
	"label": `------packages-foundation-account-ui-base-src-components-user-info-panel-index-module__label-QnKqOS`,
	"submit": `------packages-foundation-account-ui-base-src-components-user-info-panel-index-module__submit-v3XnWF`,
	"count": `------packages-foundation-account-ui-base-src-components-user-info-panel-index-module__count-cZ6U8j`,
	"upload-button": `------packages-foundation-account-ui-base-src-components-user-info-panel-index-module__upload-button-lPcyvz`,
	"uploadButton": `------packages-foundation-account-ui-base-src-components-user-info-panel-index-module__upload-button-lPcyvz`,
	"filed-readonly": `------packages-foundation-account-ui-base-src-components-user-info-panel-index-module__filed-readonly-YOi2y9`,
	"filedReadonly": `------packages-foundation-account-ui-base-src-components-user-info-panel-index-module__filed-readonly-YOi2y9`,
	"text": `------packages-foundation-account-ui-base-src-components-user-info-panel-index-module__text-EweipQ`,
	"field-edit": `------packages-foundation-account-ui-base-src-components-user-info-panel-index-module__field-edit-Ux2bRL`,
	"fieldEdit": `------packages-foundation-account-ui-base-src-components-user-info-panel-index-module__field-edit-Ux2bRL`,
	"field-edit-children": `------packages-foundation-account-ui-base-src-components-user-info-panel-index-module__field-edit-children-ej1QSf`,
	"fieldEditChildren": `------packages-foundation-account-ui-base-src-components-user-info-panel-index-module__field-edit-children-ej1QSf`,
	"field-btn": `------packages-foundation-account-ui-base-src-components-user-info-panel-index-module__field-btn-FpBgPL`,
	"fieldBtn": `------packages-foundation-account-ui-base-src-components-user-info-panel-index-module__field-btn-FpBgPL`,
	"btn": `------packages-foundation-account-ui-base-src-components-user-info-panel-index-module__btn-nd94Jo`
};
export default ___CSS_LOADER_EXPORT___;
